export default __webpack_public_path__ + "static/media/wafai-cloud.64083bff.png";